import { CourseDetails } from 'components/CourseSettings';
import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CourseSettings/desktop';
import Mobile from 'pages/CourseSettings/mobile';
import Tablet from 'pages/CourseSettings/tablet';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog, Loading } from 'shell/components';

const CourseSetting = () => {
    const { auth } = useAuth();
    const { isLoading, currentGroup } = useApp();
    const { device } = useViewport();
    const { t } = useTranslation();

    const [onBeforeChange, setOnBeforeChange] = useState({ action: (proceed) => proceed() });
    const [selected, setSelected] = useState(device === 'mobile' ? '' : 'course-details');
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        message: '',
        description: '',
        note: '',
        variant: 'destructive',
        actionButtonText: t('controls.leave', 'Leave'),
        cancelButtonText: t('controls.cancel', 'Cancel'),
        onAction: () => {},
        onCancel: () => setAlertDialog((current) => ({ ...current, open: false })),
        onClose: () => setAlertDialog((current) => ({ ...current, open: false })),
    });

    const getContent = (key) => {
        return {
            'course-details': (
                <CourseDetails
                    setSelected={setSelected}
                    setAlertDialog={setAlertDialog}
                    setOnBeforeChange={setOnBeforeChange}
                />
            ),
        }[key];
    };

    const panelList = {
        API: {
            instructor: [
                {
                    key: 'course-details',
                    value: t('course-settings.course-details.title', 'Course Details'),
                    content: getContent('course-details'),
                },
            ],
        },
        LTI: {
            instructor: [
                {
                    key: 'course-details',
                    value: t('course-settings.course-details.title', 'Course Details'),
                    content: getContent('course-details'),
                },
            ],
        },
        PASSWORD: {
            instructor: [
                {
                    key: 'course-details',
                    value: t('course-settings.course-details.title', 'Course Details'),
                    content: getContent('course-details'),
                },
            ],
        },
    };

    const props = {
        options: panelList[process.env.REACT_APP_AUTH][auth?.role],
        selected,
        onBeforeChange: onBeforeChange.action,
        onChange: setSelected,
    };

    const renderResponsiveLayout = (device) => {
        return { mobile: <Mobile {...props} />, tablet: <Tablet {...props} />, desktop: <Desktop {...props} /> }[
            device
        ];
    };

    useEffect(() => {
        if ((device === 'tablet' || device === 'desktop') && !selected) {
            setSelected('course-details');
        }
    }, [device, selected]);

    useEffect(() => {
        setOnBeforeChange({ action: (proceed) => proceed() });
    }, [selected]);

    if (isLoading) return <Loading />;

    if (auth.role === 'student' && !currentGroup) return <Loading />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <AlertDialog {...alertDialog} />
        </>
    );
};

export default CourseSetting;
